"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userInfoText = exports.userInfoIcon = exports.userInfo = exports.appTopAdditional = exports.appTopMain = exports.appTopLogo = void 0;
exports.appTopLogo = {
    cursor: 'pointer',
};
exports.appTopMain = {
    alignSelf: 'center',
    textAlign: 'center',
};
exports.appTopAdditional = {
    alignSelf: 'center',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
};
exports.userInfo = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
};
exports.userInfoIcon = {
    paddingRight: 5,
    cursor: 'pointer',
};
exports.userInfoText = {
    cursor: 'pointer',
};
//# sourceMappingURL=AppTop.styles.js.map